import { TOsiraseGetListRes } from "../../../service/master/osirase/TOsirase"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useEffect, useRef, useState } from "react"
import { OsiraseTemplateCell } from "./OsiraseTemplateCell"
import { OsiraseModal } from "./OsiraseModal"
import dayjs from "dayjs"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

export const OsiraseGrid: React.FC<{
  className?: string
  osiraseList: TOsiraseGetListRes[] | null | undefined
  modalTitle?: string
}> = (props) => {
  const gridRef = useRef<wjrGrid.FlexGrid>(null)

  const [isModalShow, setIsModalShow] = useState(false)
  const [お知らせData, setお知らせData] = useState<TOsiraseGetListRes>()

  const onCellClickEventHandler = (data: TOsiraseGetListRes) => {
    setIsModalShow(true)
    setお知らせData(data)
  }

  useEffect(() => {
    if (
      gridRef == null ||
      gridRef.current == null ||
      gridRef.current.control == null ||
      props.osiraseList == null
    )
      return
    const grid = gridRef.current.control as wjcGrid.FlexGrid
    grid.itemsSource = props.osiraseList
  }, [props.osiraseList])

  return (
    <>
      <wjrGrid.FlexGrid
        className="max-h-16rem"
        autoRowHeights={true}
        isReadOnly={true}
        sortingColumn={true}
        headersVisibility={wjcGrid.HeadersVisibility.Column}
        selectionMode={wjcGrid.SelectionMode.None}
        ref={gridRef}>
        <wjrGrid.FlexGridColumn
          width={100}
          binding={"お知らせ分類区分名称1"}
          header="カテゴリ"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          wordWrap={true}
          width={"*"}
          binding={"タイトル"}>
          <wjrGrid.FlexGridCellTemplate
            cellType={wjrGrid.CellTemplateType.Cell}
            template={OsiraseTemplateCell(onCellClickEventHandler)}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="更新日時"
          format={"d"}
          width={160}
          header="更新日時">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TOsiraseGetListRes>
            ) => {
              let dDate = ""
              if (context.item.更新日時)
                dDate = dayjs(context.item.更新日時).format(
                  "YYYY/MM/DD HH:mm:ss"
                )

              return (
                <>
                  <span>{dDate}</span>
                </>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
      </wjrGrid.FlexGrid>
      <OsiraseModal
        isShow={isModalShow}
        setIsShow={setIsModalShow}
        title={"お知らせ"}
        Osirase={お知らせData}></OsiraseModal>
    </>
  )
}
